{
  "fr": {
    "inspiration": {
      "actions": {
        "delete": "Supprimer",
        "deleteMultipleInspirations": "Supprimer...",
        "delete_cancel": "Annuler la suppression",
        "goBackToInspirationLists": "Inspirations",
        "new": "Inspiration"
      },
      "labels": {
        "move_to_upload": "Mettez votre document en ligne sur la page d'accueil ou cliquez sur l'icône pour le télécharger.",
        "noInspirations": "Pas encore d'inspiration",
        "upload_autoclose": "Cette fenêtre se fermera automatiquement si toutes les images sont téléchargées."
      },
      "toasts": {
        "upload_success": "{count} Inspiration téléchargé avec succès | {count} Inspirations téléchargées avec succès"
      }
    }
  }
}
